"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var player_button_1 = require("player-button");
exports.Button = player_button_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Button"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Button/index.js
// module id = 29
// module chunks = 0